package cc.bluepeak.clubmanager.site.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import cc.bluepeak.clubmanager.site.Res
import cc.bluepeak.clubmanager.site.components.layouts.PageLayoutData
import cc.bluepeak.clubmanager.site.components.widgets.Accordion
import cc.bluepeak.clubmanager.site.components.widgets.AccordionItem
import cc.bluepeak.clubmanager.site.components.widgets.FieldTag
import cc.bluepeak.clubmanager.site.components.widgets.LineTag
import cc.bluepeak.clubmanager.site.styles.CardStyle
import cc.bluepeak.clubmanager.site.styles.PaddedCardStyle
import cc.bluepeak.clubmanager.site.styles.Theme
import cc.bluepeak.clubmanager.site.styles.UnderlinedInputVariant
import com.varabyte.kobweb.compose.css.BackgroundPosition
import com.varabyte.kobweb.compose.css.BackgroundSize
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.components.forms.TextInput
import com.varabyte.kobweb.silk.components.icons.lucide.LucideCheck
import com.varabyte.kobweb.silk.components.icons.lucide.LucideCloudDownload
import com.varabyte.kobweb.silk.components.icons.lucide.LucideHeartHandshake
import com.varabyte.kobweb.silk.components.icons.lucide.LucideKeyRound
import com.varabyte.kobweb.silk.components.icons.lucide.LucidePhone
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.w3c.fetch.CORS
import org.w3c.fetch.Headers
import org.w3c.fetch.MANUAL
import org.w3c.fetch.NO_CACHE
import org.w3c.fetch.RequestCache
import org.w3c.fetch.RequestCredentials
import org.w3c.fetch.RequestInit
import org.w3c.fetch.RequestMode
import org.w3c.fetch.RequestRedirect
import org.w3c.fetch.SAME_ORIGIN
import kotlin.time.Duration.Companion.seconds

@InitRoute
fun initRegister(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(Res.string.ea_tag, Res.string.ea_title))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun Register() {
    val ctx = rememberPageContext()
    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(2.cssRem)) {
        SimpleGrid(numColumns(1, md = 2), CardStyle.toModifier().fillMaxWidth().padding(1.cssRem)) {
            Column(
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.End,
                modifier = Modifier.fillMaxWidth()
            ) {
                Column(Modifier.maxWidth(500.px)) {
                    FieldTag(Res.string.ea_tag)
                    H1(Modifier.whiteSpace(WhiteSpace.BreakSpaces).toAttrs()) { Text(Res.string.ea_title) }
                    P(
                        Modifier.lineHeight(1.4).fontWeight(400).color(Theme.secondary)
                            .margin(top = 1.cssRem, bottom = 2.cssRem)
                            .toAttrs()
                    ) {
                        Text(Res.string.ea_desc)
                    }

                }
            }
            Column(PaddedCardStyle.toModifier()) {
                H2(Modifier.margin(bottom = 1.cssRem).toAttrs()) {
                    Text(Res.string.ea_cta)
                }
                SpanText(Res.string.contact_form_name)
                var name by remember { mutableStateOf("") }
                TextInput(
                    name, { name = it }, variant = UnderlinedInputVariant, placeholder = Res.string.contact_form_name,
                    modifier = Modifier.fillMaxWidth().margin(bottom = 1.cssRem),
                    required = true
                )
                SpanText(Res.string.ea_club_name)
                var club by remember { mutableStateOf("") }
                TextInput(
                    club,
                    { club = it },
                    variant = UnderlinedInputVariant,
                    placeholder = Res.string.ea_club_name_placeholder,
                    modifier = Modifier.fillMaxWidth().margin(bottom = 1.cssRem),
                    required = true
                )
                SpanText(Res.string.contact_form_email)
                var email by remember { mutableStateOf("") }
                LaunchedEffect(Unit) {
                    email = ctx.route.queryParams["email"] ?: ""
                }
                Input(
                    InputType.Email,
                    email,
                    { email = it },
                    placeholder = Res.string.email_placeholder,
                    variant = UnderlinedInputVariant,
                    modifier = Modifier.fillMaxWidth().margin(bottom = 1.cssRem),
                    required = true
                )
                val scope = rememberCoroutineScope()
                var sent by remember { mutableStateOf(false) }
                Button(
                    onClick = {
                        scope.launch {
                            window.fetch(
                                input = "https://autocomms.bluepeak.cc/api/message", init = RequestInit(
                                    method = "POST",
                                    headers = Headers().apply {
                                        append("Content-Type", "application/json")
                                    },
                                    body = """{
                          "form": "clubmanager.cc/early-access",
                          "email": "$email",
                          "content": "$club",
                          "name": "${name.ifBlank { "Anonymous" }}"
                        }""",
                                    mode = RequestMode.CORS,
                                    cache = RequestCache.NO_CACHE,
                                    credentials = RequestCredentials.SAME_ORIGIN,
                                    redirect = RequestRedirect.MANUAL,
                                    referrerPolicy = "origin",
                                    keepalive = true,
                                )
                            ).await()
                            sent = true
                            delay(5.seconds)
                            name = ""
                            email = ""
                            club = ""
                            sent = false
                        }
                    },
                    Modifier.fillMaxWidth(),
                    enabled = !sent && name.isNotBlank() && email.isNotBlank() && club.isNotBlank()
                ) {
                    if (sent) LucideCheck()
                    else Text(Res.string.ea_cta)
                }
                SpanText(Res.string.ea_note, Modifier.fontWeight(400).fontSize(FontSize.Smaller).margin(top = 1.cssRem))
            }
        }
        SimpleGrid(
            numColumns(1, 2), PaddedCardStyle.toModifier().fillMaxWidth()
                .gap(1.cssRem)
                .backgroundImage(url("""/${Res.string.locale}/${Res.image.fabric4}"""))
                .background {
                    size(BackgroundSize.Cover)
                    position(BackgroundPosition.of(CSSPosition.Center))
                }) {
            Column {
                LineTag(Res.string.ea_future_tag, Modifier.color(Theme.white))
                H1(Modifier.whiteSpace(WhiteSpace.BreakSpaces).color(Theme.white).toAttrs()) {
                    Text(Res.string.ea_future_title)
                }
                P(
                    Modifier.lineHeight(1.4).fontWeight(400).color(Theme.white)
                        .margin(top = 1.cssRem, bottom = 2.cssRem)
                        .toAttrs()
                ) {
                    Text(Res.string.ea_future_desc)
                }
            }
            Box(contentAlignment = Alignment.Center) {
                Column(
                    PaddedCardStyle.toModifier().fillMaxWidth(),
                    verticalArrangement = Arrangement.spacedBy(1.cssRem)
                ) {
                    H2(Modifier.margin(bottom = 1.cssRem).toAttrs()) {
                        Text(Res.string.ea_future_headline)
                    }
                    Row(horizontalArrangement = Arrangement.spacedBy(1.cssRem)) {
                        LucideKeyRound(size = 1.5.cssRem, color = Theme.primary)
                        Column {
                            H3 {
                                Text(Res.string.ea_future_feature_early_access_title)
                            }
                            P(Modifier.color(Theme.secondary).toAttrs()) {
                                Text(Res.string.ea_future_feature_early_access_desc)
                            }
                        }
                    }
                    Row(horizontalArrangement = Arrangement.spacedBy(1.cssRem)) {
                        LucidePhone(size = 1.5.cssRem, color = Theme.primary)
                        Column {
                            H3 {
                                Text(Res.string.ea_future_feature_communication_title)
                            }
                            P(Modifier.color(Theme.secondary).toAttrs()) {
                                Text(Res.string.ea_future_feature_communication_desc)
                            }
                        }
                    }
                    Row(horizontalArrangement = Arrangement.spacedBy(1.cssRem)) {
                        LucideCloudDownload(size = 1.5.cssRem, color = Theme.primary)
                        Column {
                            H3 {
                                Text(Res.string.ea_future_feature_updates_title)
                            }
                            P(Modifier.color(Theme.secondary).toAttrs()) {
                                Text(Res.string.ea_future_feature_updates_desc)
                            }
                        }
                    }
                    Row(horizontalArrangement = Arrangement.spacedBy(1.cssRem)) {
                        LucideHeartHandshake(size = 1.5.cssRem, color = Theme.primary)
                        Column {
                            H3 {
                                Text(Res.string.ea_future_feature_support_title)
                            }
                            P(Modifier.color(Theme.secondary).toAttrs()) {
                                Text(Res.string.ea_future_feature_support_desc)
                            }
                        }
                    }
                }
            }
        }

        Column(PaddedCardStyle.toModifier().fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
            FieldTag(Res.string.faq_tag)
            H1(Modifier.margin(bottom = 2.cssRem).toAttrs()) {
                Text(Res.string.faq_title)
            }
            Accordion(
                listOf(
                    AccordionItem(Res.string.ea_faq_early_access) {
                        P {
                            Text(Res.string.ea_faq_early_access_answer)
                        }
                    },
                    AccordionItem(Res.string.ea_faq_access) {
                        P {
                            Text(Res.string.ea_faq_access_answer)
                        }
                    },
                    AccordionItem(Res.string.ea_faq_pricing) {
                        P {
                            Text(Res.string.ea_faq_pricing_answer)
                        }
                    },
                    AccordionItem(Res.string.ea_faq_data) {
                        P {
                            Text(Res.string.ea_faq_data_answer)
                        }
                    },
                    AccordionItem(Res.string.ea_faq_feedback) {
                        P {
                            Text(Res.string.ea_faq_feedback_answer)
                        }
                    },
                )
            )
        }
    }
}